/** @jsxRuntime classic */
/** @jsx jsx */
import { useState } from 'react';
import { jsx, css } from '@emotion/react';
import { Spinner } from '@fluentui/react';
import { Formik } from 'formik';
import { useParams } from 'react-router-dom';
import FormContent from '../Components/FormContent';
import { validationSchema, mapInitialValues } from '../Helpers/CopyAndFunctions';
import useDataState from '../Helpers/useDataState';
import useHandleSave from '../Helpers/useHandleSave';
import FeatureSummary from '../../../../Util/FeatureSummary';


const WizardPage = () => {
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const { seriesId: seriesIdFromParams } = useParams();
    const {
        eligibleData,
        isReady,
        submitForm,
        seriesData
    } = useDataState(seriesIdFromParams);

    if (!isReady) {
        return <Spinner className="absolute-center" text="Loading Series Settings..." />;
    }

    return (
        <Formik
            validateOnMount={true}
            initialValues={mapInitialValues({seriesData})}
            onSubmit= {async (values, { resetForm }) => {
                if (!values.conPlaylistID) values.conPlaylistID = 0; 
                try {
                    const result = await submitForm({ data: values });
                    if (result.data.success) {
                        const updatedData = { ...values };
                        resetForm({ values: updatedData });
                    }
                    setShowSuccess(result.data.success);
                    setShowError(!result.data.success);
                } catch (error) {
                    setShowError(true);
                }
                setTimeout(() => {
                    setShowSuccess(false);
                }, 5000);
            }}
            isInitialValid={false}
            validationSchema={validationSchema}
        >
            {({ values, isValid, handleSubmit }) => {
                const handleSave = useHandleSave(setShowError);

                return values ? (
                        <>
                            <FormContent 
                                eligibleData={eligibleData} 
                                handleSave={() => handleSave(isValid, handleSubmit)}
                                showSuccess={showSuccess}
                                showError={showError}
                            />
                            <FeatureSummary
                                label="About Content Series"
                                summary="Create or edit content series (playlists) to organize related content items together. Series help users discover curated collections of articles, videos, and other content around specific themes or topics."
                            />
                        </>
                    ) : null;
            }}
        </Formik>
    );
};

export default WizardPage;